import React from "react";

export const {
    Provider: AuthServiceProvider,
    Consumer: AuthServiceConsumer
} = React.createContext();